import { Box, Card, Grid, CircularProgress, IconButton, Typography, Button } from "@mui/material";
import { useSelector } from "react-redux";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate, useParams } from "react-router-dom";
import { MdOutlineWatchLater } from "react-icons/md";
import CustomTable from "../../../components/customTable/customTable";
import { useCallback, useEffect, useMemo, useState } from "react";
import { API_URL } from "../../../appConstants";
import { useTMutation } from "../../../utils/useTMutation";
import showToast from "../../../components/Hot-Toast/showToast";
import IMAGE from "../../../assets/images/big/abcz.png";
import { useTQuery } from "../../../utils/useTQuery";
import AssignedClinicianModal from "../../../components/DialogPopup/AssignedClinicianModal";
import SliderModal from "../../../components/DialogPopup/SliderModal";
import { useAccessControl } from '../../../components/AccessControl';

const ViewJobApplicantsDetails = ({ access }) => {
    const { ID } = useParams();
    const { userDetails } = useSelector(state => state.user);
    const navigate = useNavigate();
    const [event, setEvent] = useState({})
    const { isFullAccess } = useAccessControl(access);
    // const { jobData } = useSelector(state => state.job);
    const [jobData, setJobData] = useState({});
    const [jobAndCountList, setJobAndCountList] = useState([]);
    const [clinicianList, setClinicianList] = useState([]);
    console.log("jobData", jobData);
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [checkedItems, setCheckedItems] = useState([]);

    const [openSlider, setOpenSlider] = useState(false);
    const [sliderValue, setSliderValue] = useState(10);
    const [action, setAction] = useState(null);
    const [note, setNote] = useState('');


    const { data, refetch, isLoading } = useTQuery(
        ["jobDetails", ID],
        `/job/applicantsAndJobDetails?${new URLSearchParams({ ID }).toString()}`,
        'get',
        ID,
    );

    const AssignedClinicianToJob = useTMutation("/job/submitAssignClinician", "post", (data => {
        if (data?.STATUS) {
            handleClose();
            showToast("success", data.MESSAGE, 3000);
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    }));

    const jobRoleRegistered = useTQuery(
        ["jobs_roles", data?.OUTPUT?.USER_ID],
        `/job/jobRoleClinicianCounts?${new URLSearchParams({
            USER_ID: data?.OUTPUT?.USER_ID, ID,

        }).toString()}`,
        'get',
        {
            enabled: !!data?.OUTPUT?.USER_ID, // Only run this query if jobDetailsData.OUTPUT exists
        }
    );
    console.log("jobData?.ID", jobData?.ID);

    const CliniciansInJobRole = useTQuery(
        ["clinician", selectedOption],
        `/job/fetchClinicianByJobId?${new URLSearchParams({
            JobRoleID: selectedOption, jobID: jobData?.ID, postedJob: ID,
        }).toString()}`,
        'get',
        !!jobData?.ID // Enable query only when jobData?.ID has a truthy value
    );
    useEffect(() => {
        if (data?.STATUS) {
            data?.OUTPUT && setJobData(data?.OUTPUT);
            setSliderValue(data?.OUTPUT?.PAY_AMOUNT_FROM);
        }
    }, [data?.OUTPUT, data?.STATUS]);

    useEffect(() => {
        if (CliniciansInJobRole?.data?.STATUS) {
            CliniciansInJobRole?.data?.OUTPUT && setClinicianList(CliniciansInJobRole?.data?.OUTPUT);
        }
    }, [CliniciansInJobRole?.data?.OUTPUT, CliniciansInJobRole?.data?.STATUS]);

    useEffect(() => {
        if (jobRoleRegistered?.data?.STATUS) {
            jobRoleRegistered?.data?.OUTPUT && setJobAndCountList(jobRoleRegistered?.data?.OUTPUT);
        }
    }, [jobRoleRegistered?.data?.OUTPUT, jobRoleRegistered?.data?.STATUS]);



    let col = [
        {
            name: 'Clinician',
            selector: row => row?.clinician?.FULL_NAME,
            reorder: true,
            sortable: true,
            // style: { paddingLeft: "45px" }
        },
        {
            name: 'Role',
            selector: row => row.clinician?.jobRole?.ROLE_NAME,
            reorder: true,
            sortable: true,
            // style: { paddingLeft: "45px" }
        },
        {
            name: 'Email Address',
            selector: row => row?.clinician?.EMAIL_ADDRESS,
            reorder: true,
            sortable: true,
            // style: { paddingLeft: "45px" }
        },
        {
            name: 'STATUS',
            selector: row => row?.clinicianStatus,
            reorder: true,
            sortable: true,
            // style: { paddingLeft: "45px" }
        },
        // {
        //     name: 'ACTIONS',
        //     button: true,
        //     cell: row => (
        //         <div style={{ paddingLeft: "15px" }}>
        //             <Tooltip title="Edit Job">
        //                 <IconButton size="small" onClick={() => {
        //                     dispatch(setPortalControlBy('facility'));
        //                     navigate(`/facility/clinican-users/${row?.USER_ID}/${row?.JOB_ID}`)
        //                 }}>
        //                     <MoreHorizIcon />
        //                 </IconButton>
        //             </Tooltip>
        //         </div>
        //     ),
        //     reorder: true,
        //     center: true
        // }

    ]


    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setCheckedItems([]);
        setSelectedOption('');
    };

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value)
    };
    const handleCheckboxChange = (event, id) => {
        setCheckedItems((prev) =>
            event.target.checked
                ? [...prev, id]
                : prev.filter((selectedId) => selectedId !== id)
        );
    };

    const handleSubmit = () => {
        const response = AssignedClinicianToJob.mutateAsync({ checkedItems, jobID: ID, facilityId: jobData?.user?.ID, hiringBy: "Admin", workType: "Job" })
        if (response.STATUS) {
            refetch();
            console.log("----------------------------------D");
        }
    };
    ////////////////////SLIDER FXN CODE BELOW //////////////////////////////////////////////////////////////////////////////////////////////////////



    const handleOpenSlider = () => {
        setSliderValue(sliderConfig.initialValue || sliderConfig.min); // Reset sliderValue
        setOpenSlider(true);
    };
    const handleCloseSlider = () => {
        setOpenSlider(false);
        setAction(null); // Reset action
        setNote(''); // Reset note
    };
    const handleSliderChange = useCallback((event, newValue) => {
        console.log('New Slider Value:', newValue);
        setSliderValue(newValue); // Update parent state
    }, []);

    const handleAction = useCallback(async (actionType) => {
        setAction(actionType);
        await approvalMutation.mutateAsync({ ID, note, actionType, sliderValue });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ID, note, sliderValue]);

    const handleNoteChange = useCallback((event) => {
        setNote(event.target.value);
    }, []);

    const sliderConfig = useMemo(() => ({
        min: jobData.PAY_AMOUNT_FROM || 0,
        max: jobData.PAY_AMOUNT_TO,
        step: 0.1,
        initialValue: jobData.PAY_AMOUNT_FROM
    }), [jobData.PAY_AMOUNT_FROM, jobData.PAY_AMOUNT_TO]);

    const approvalMutation = useTMutation("/job/jobHiringRequestApproval", "post", (data) => {
        if (data?.STATUS) {
            showToast("success", data.MESSAGE, 3000);
            setOpenSlider(false);
            refetch();
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    })
    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }
    return (
        <>
            <Grid container >

                <Box onClick={() => navigate(-1)} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <IconButton >
                        <ChevronLeftIcon />
                    </IconButton>
                    <Typography variant="body1"  >
                        Back
                    </Typography>
                </Box>

                <Grid item lg={12}>
                    <Card>
                        <Grid container >
                            <Grid item lg={12} p={1}>
                                {/* <Box display="flex" justifyContent="space-between">
                                    <Box display="flex" visibility="hidden"></Box>
                                    <Box display="flex" >
                                        <Grid mt={1}>
                                            <Typography style={{ backgroundColor: jobData?.JOB_STATUS === "Clinician Hired" ? 'linear-gradient(to right,#4eb3e8,#6ebe44)' : "#f6b613", borderRadius: "20px", padding: "1px 20px", color: "#ffffff", fontWeight: 500, fontSize: "14px" }}>{jobData.adminActionType || "Pending Request"}</Typography>
                                        </Grid>
                                    </Box>
                                </Box> */}

                                <Box display="flex" justifyContent="space-between">
                                    <Box>
                                        <Box>

                                            <Typography variant="h2" style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{jobData?.jobs_role?.ROLE_NAME}</Typography>
                                            <Typography variant="h4" pt={1} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>
                                            <Typography variant="h4" pt={1} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>Glendora, CA</Typography>
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography style={{ backgroundColor: jobData?.JOB_STATUS === "Clinician Hired" ? 'linear-gradient(to right,#4eb3e8,#6ebe44)' : "#f6b613", borderRadius: "20px", padding: "1px 20px", color: "#ffffff", fontWeight: 500, fontSize: "14px" }}>{jobData.adminActionType || "Pending Request"}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            {/* <Grid item lg={6} p={2}>

                                <Box>

                                    <Typography variant="h2" pt={1} style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{jobData?.jobs_role?.ROLE_NAME}</Typography>
                                    <Typography variant="h4" pt={1} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>
                                    <Typography variant="h4" pt={1} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>Glendora, CA</Typography>
                                </Box>

                            </Grid> */}
                            <Grid item lg={12} >
                                <Box px={1.5} display="flex" justifyContent="space-between">
                                    <Box display="flex" gap={3} justifyContent="flex-start">
                                        {jobData?.jobs_role?.ROLE_NAME && (
                                            <Typography
                                                sx={{
                                                    backgroundColor: '#eef7e9',
                                                    borderRadius: '20px',
                                                    padding: '10px 20px',
                                                    color: 'black',
                                                    fontWeight: 500,
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {jobData.jobs_role.ROLE_NAME}
                                            </Typography>
                                        )}
                                        {jobData?.JOB_TYPE && (
                                            <Typography
                                                sx={{
                                                    backgroundColor: '#eef7e9',
                                                    borderRadius: '20px',
                                                    padding: '10px 20px',
                                                    color: 'linear-gradient(to right,#4eb3e8,#6ebe44)',
                                                    fontWeight: 500,
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {jobData?.JOB_TYPE}
                                            </Typography>
                                        )}
                                        {jobData?.SERVICE_TYPE && (
                                            <Typography
                                                sx={{
                                                    backgroundColor: '#eef7e9',
                                                    borderRadius: '20px',
                                                    padding: '10px 20px',
                                                    color: 'linear-gradient(to right,#4eb3e8,#6ebe44)',
                                                    fontWeight: 500,
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {jobData?.SERVICE_TYPE}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box display="flex" gap={3} justifyContent="flex-end">
                                        {isFullAccess && (
                                            jobData.adminActionType === "Approved" ?
                                                <Button variant="contained" color="primary" onClick={handleOpen}>
                                                    + Assigned Clinician
                                                </Button>
                                                :
                                                <Button Button variant="contained" color="success" onClick={handleOpenSlider}>
                                                    Approval & Set Pay Range
                                                </Button>
                                        )}
                                    </Box>


                                </Box>
                            </Grid>

                        </Grid>
                    </Card>
                </Grid >
            </Grid >

            <Grid mt={2}>
                {(jobData?.adminActionType === "Approved") ?
                    (<CustomTable
                        column={col}
                        event={(e) => { setEvent(e) }}
                        url={"/job/fetchAssignedClinician"}
                        headline={"Applicants"}
                        payload={{ jobID: ID, }}
                    />)
                    :
                    <Typography
                        sx={{
                            backgroundColor: '#eef7e9',
                            borderRadius: '20px',
                            padding: '10px 20px',
                            color: 'linear-gradient(to right,#4eb3e8,#6ebe44)',
                            fontWeight: 500,
                            fontSize: '14px',
                        }}
                    >
                        The facility has sent you a job request for hiring a clinician. Please approve or reject the job and set the pay scale within the range provided by the facility.
                    </Typography>
                }
            </Grid>


            <Grid container spacing={1} justifyContent="space-around" mt={2} px={3} pb={18} >
                <Grid item lg={4} pb={2}>
                    <Card  >
                        <Grid container alignItems="center" spacing={1} justifyContent="space-around" px={3} pb={3}>
                            <Grid item xs={12} sm={12} display="flex" gap={3}>
                                <Typography pt={2}>
                                    <img
                                        src={jobData?.user?.PROFILE_IMAGE_PATH
                                            ? API_URL + "user/viewFile?fileName=" + jobData?.user?.PROFILE_IMAGE_PATH
                                            : IMAGE}
                                        alt="profile"
                                    // style={{ height: '150px', width: '150px' }}
                                    />

                                </Typography>
                                <Typography>
                                    <Box pt={2}>
                                        <Typography style={{ fontWeight: 500, fontSize: "14px", color: "#000000", opacity: "87%" }}>{jobData?.user?.FACILITY_NAME}</Typography>
                                        <Typography style={{ fontWeight: 400, fontSize: "12px", color: "#000000", opacity: "60%" }}>{jobData?.user?.STREET_ADDRESS}</Typography>
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box>
                                    <Typography variant="h2" pt={2} style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{jobData?.jobs_role?.ROLE_NAME}</Typography>
                                    <Typography variant="h4" pt={2} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>
                                    <Box display="flex" gap={1}>
                                        {/* <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography> */}
                                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>
                                            {jobData?.SERVICE_DURATION
                                                ? jobData?.SERVICE_DURATION?.map((data) =>
                                                    <Box display="flex" gap={1}>
                                                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                                                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data?.JOB_DAY}</Typography>
                                                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_IN_TIME}</Typography>  <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>-</Typography>
                                                        <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_OUT_TIME}</Typography>
                                                    </Box>
                                                )

                                                :
                                                jobData?.JOB_SERVICE_WITH_DAY_TIME &&
                                                (<Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>
                                                    {jobData.JOB_SERVICE_WITH_DAY_TIME[0]?.JOB_DAY}-{jobData.JOB_SERVICE_WITH_DAY_TIME[jobData.JOB_SERVICE_WITH_DAY_TIME.length - 1]?.JOB_DAY}
                                                </Typography>)
                                            }
                                        </Typography>
                                    </Box>
                                    <Typography variant="h4" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.facility_addlocation?.STREET_ADDRESS}</Typography>
                                </Box>
                            </Grid>
                        </Grid>

                        <hr style={{ marginTop: "20px", color: "#000000", opacity: "60%", width: "90%", margin: "0 auto" }} />

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Title</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.jobs_role?.ROLE_NAME}</Typography>
                                </Box>
                            </Typography>

                        </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Specialty</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>s{jobData?.specialty?.SPECIALTY_NAME}</Typography>
                                </Box>
                            </Typography>

                        </Box>
                        {jobData?.STAFFING_SOLUTION && <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Staffing Solution</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData.STAFFING_SOLUTION}</Typography>
                                </Box>
                            </Typography>

                        </Box>}


                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Job Type</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData.JOB_TYPE}</Typography>
                                </Box>
                            </Typography>

                        </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Shift Type</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData.SERVICE_TYPE}</Typography>
                                </Box>
                            </Typography>

                        </Box>

                         <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                                                        <Typography>
                                                            <Box>
                                                                <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Positions Available</Typography>
                                                                <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.REQUIRED_APPLICANTS ? jobData.REQUIRED_APPLICANTS : (jobData?.REQUIRED_APPLICANTS === 0 ? '0' : 'N/A')}</Typography>
                                                            </Box>
                                                        </Typography>
                                                    </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Start Date</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>
                                </Box>
                            </Typography>

                        </Box>

                         <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                                                        <Typography>
                                                            <Box>
                                                                <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>End Date</Typography>
                                                                <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.SERVICE_END_DATE ? new Date(jobData.SERVICE_END_DATE).toDateString() : 'N/A'}</Typography>
                                                            </Box>
                                                        </Typography>
                        
                                                    </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Working Days</Typography>

                                </Box>
                                <Box>

                                    {jobData?.SERVICE_DURATION
                                        ? jobData?.SERVICE_DURATION?.map((data) =>
                                            <Box display="flex" gap={1}>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data?.JOB_DAY}</Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_IN_TIME}</Typography>  <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>-</Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_OUT_TIME}</Typography>
                                            </Box>
                                        )

                                        :
                                        jobData?.JOB_SERVICE_WITH_DAY_TIME &&
                                        (<Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>
                                            {jobData.JOB_SERVICE_WITH_DAY_TIME[0]?.JOB_DAY}-{jobData.JOB_SERVICE_WITH_DAY_TIME[jobData.JOB_SERVICE_WITH_DAY_TIME.length - 1]?.JOB_DAY}
                                        </Typography>)
                                    }
                                </Box>
                            </Typography>

                        </Box>
                        {/* <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }} >Time</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}> -</Typography>
                                </Box>
                            </Typography>

                        </Box> */}
                        {jobData.SERVICE_TYPE !== "Recurring" && (
                            <Box display="flex" justifyContent="space-between" pt={1.2}>

                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Time</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.JOB_IN_TIME} - {jobData?.JOB_OUT_TIME}</Typography>
                                </Box>
                                {/* {jobData?.SERVICE_DURATION ?
                                            <Box>
                                              <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.SERVICE_DURATION?.[0]?.JOB_IN_TIME} - {jobData?.SERVICE_DURATION?.[0]?.JOB_OUT_TIME}</Typography>
                                            </Box>
                                            : jobData?.JOB_SERVICE_WITH_DAY_TIME &&
                                            (
                                              <Box>
                                                <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.JOB_SERVICE_WITH_DAY_TIME?.[0]?.JOB_IN_TIME} - {jobData?.JOB_SERVICE_WITH_DAY_TIME?.[0]?.JOB_OUT_TIME}</Typography>
                                              </Box>
                                            )
                                          } */}

                            </Box>
                        )}
                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Pay</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>${jobData.PAY_AMOUNT_FROM}-{jobData.PAY_AMOUNT_TO}/hr</Typography>
                                </Box>
                            </Typography>

                        </Box>
                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Location</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }} >
                                        {/* {jobData?.facility_addlocation?.STREET_ADDRESS} */}
                                        {jobData?.user?.STREET_ADDRESS}
                                        </Typography>
                                </Box>
                            </Typography>

                        </Box>

                    </Card>


                </Grid>
                <Grid item lg={8} mt={0}>
                    <Card >
                        <Grid container alignItems="center" spacing={1} justifyContent="space-around" p={3} pb={3}>
                            <Grid item xs={12} sm={12} display="flex" justifyContent="space-between">

                                <Typography variant="h3" style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>
                                    Job Description
                                </Typography>

                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography id="delete-modal-title" variant="h6" component="h2" style={{ fontWeight: 400, fontSize: "16px", color: "#000000", opacity: "60%" }}>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: jobData.JOB_DESCRIPION }}
                                    />
                                </Typography >


                            </Grid>
                            <Grid item xs={12} sm={12} mt={3} >

                                <Box display="flex" justifyContent="space-between">
                                    <Typography variant="h3" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>
                                        Responsibilities:
                                    </Typography>

                                </Box>


                                <Typography px={2.5} pt={1}>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: jobData.JOB_RESPONSIBILITY }}
                                    />
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                {/* <Typography id="delete-modal-title"  variant="h5" component="h2">
                           {jobData?.JOB_RESPONSIBILITY}
                    </Typography> */}
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid >
            {open && <AssignedClinicianModal
                open={open}
                onClose={handleClose}
                title="Assign Clinician"
                options={jobAndCountList}
                listItems={clinicianList}
                selectedOption={selectedOption}
                onOptionChange={handleOptionChange}
                isChecked={checkedItems}
                onCheckboxChange={handleCheckboxChange}
                onSubmit={handleSubmit}
            />}

            {
                openSlider && <SliderModal
                    open={openSlider}
                    onClose={handleCloseSlider}
                    // title="Set a PayScale (rate/hr)"
                    title={action === "Rejected" ? "Reject Note" : "Set a PayScale (rate/hr)"}
                    sliderConfig={sliderConfig}
                    sliderValue={sliderValue}
                    onSliderChange={handleSliderChange}
                    action={action}
                    onAction={handleAction}
                    note={note}
                    onNoteChange={handleNoteChange}
                />
            }
        </>


    )
};

export default ViewJobApplicantsDetails;

